module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f368eb36724d400b79a10cd5abf90697.png";